import { BooleanField, DateField, NumberField, useRecordContext } from "react-admin";
import { Box, Grid, Typography, Stack, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExamRoomsShow from "./ExamRoomsShow";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ExamsSlotsShow = ({ campaignIsStarted, hasRoomsWithCandidates }) => {
  const exam = useRecordContext();

  if (!exam) {
    return;
  }

  return (
    <Box>
      {exam.examDays?.map((day, dayIndex) => (
        <Accordion
          sx={{ mb: 2 }}
          key={dayIndex}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#4E2683" }} />}>
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Typography
                variant="body2"
                fontWeight="bold"
                fontSize={16}
                color={"#4E2683"}
              >
                Дата на изпита:
              </Typography>
              <DateField
                source="examStartTimestamp"
                record={day}
                locales="bg-BG"
                fontSize={14}
                fontWeight="bold"
              />
              <Typography
                variant="body2"
                fontWeight="bold"
                fontSize={16}
                color="#4E2683"
                sx={{ mb: 1 }}
              >
                Резервен ден
              </Typography>
              <BooleanField
                source="isBackup"
                record={day}
              />
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            {/* Slots */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                border: "1px solid #E0E0E0", // light gray border
                borderRadius: 2, // rounded corners
                p: 2, // padding inside
                backgroundColor: "#FAFAFA", // very light background
                height: "100%", // make box full height if needed
              }}
            >
              {day.timeSlots?.map((slot, slotIndex) => (
                <Grid
                  container
                  spacing={1}
                  key={slotIndex}
                  sx={{ mb: 1 }}
                >
                  <Grid
                    item
                    xs={6}
                    md={2}
                  >
                    <Typography
                      variant="body2"
                      fontWeight="bold"
                      color="text.primary"
                      sx={{ mb: 1 }}
                    >
                      Начало
                    </Typography>
                    <DateField
                      source="startTime"
                      record={slot}
                      locales="bg-BG"
                      showTime
                      showDate={false}
                      options={{ hour: "2-digit", minute: "2-digit" }}
                    />
                  </Grid>
                  {slot?.endTime && (
                    <Grid
                      item
                      xs={6}
                      md={2}
                    >
                      <Typography
                        variant="body2"
                        fontWeight="bold"
                        color="text.primary"
                        sx={{ mb: 1 }}
                      >
                        Край
                      </Typography>
                      <DateField
                        source="endTime"
                        record={slot}
                        locales="bg-BG"
                        showTime
                        showDate={false}
                        options={{ hour: "2-digit", minute: "2-digit" }}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={6}
                    md={2}
                  >
                    <Typography
                      variant="body2"
                      fontWeight="bold"
                      color="text.primary"
                      sx={{ mb: 1 }}
                    >
                      Капацитет
                    </Typography>
                    <NumberField
                      source="capacity"
                      record={slot}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    md={2}
                  >
                    <Typography
                      variant="body2"
                      fontWeight="bold"
                      color="text.primary"
                      sx={{ mb: 1 }}
                    >
                      Резервен час
                    </Typography>
                    <BooleanField
                      source="isBackup"
                      record={slot}
                    />
                  </Grid>
                  {!day.examPassed && (
                    <Grid
                      container
                      spacing={2}
                      justifyContent="center"
                      alignItems="center"
                      sx={{ margin: 1 }}
                    >
                      <Grid
                        item
                        xs={12}
                        md={12}
                        sx={{ textAlign: "center" }}
                      >
                        <ExamRoomsShow
                          rooms={slot.roomsShow}
                          exam={exam}
                          campaignIsStarted={campaignIsStarted}
                          hasRoomsWithCandidates={hasRoomsWithCandidates}
                        />
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              ))}
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default ExamsSlotsShow;
